<script>
import {mapGetters} from "vuex";
import AnalyticsDetailRow from "@/components/MultiConnect/Analytics/AnalyticsDetailRow.vue";
import Loading from "@/components/Loading.vue";

export default {
  name: "PartnersAnalytics",
  components: {Loading, AnalyticsDetailRow},
  props: {
    isPdf: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    view(type) {
      this.$router.push({
        name: "partnerAnalytics",
        query: {
          type: type,
        },
        params: {
          eventId: this.currentEvent.id,
        }});
    }
  },
  computed: {
    ...mapGetters(["currentEvent", "linkedSubEvents", "linkedSessions", "eventPartners"]),
    partnerAnalytics() {
      return this.currentEvent.analyticsData.partnersAnalytics;
    },
    partnersData() {
      return this.partnerAnalytics.partnersByType;
    }
  },

}
</script>

<template>
  <div>
    <v-card :outlined="isPdf ? false : true" :class="isPdf ? `pb-10` : `pb-2`">
      <v-card-title class="pt-4 pb-2">Partners</v-card-title>
      <div>
        <v-card-subtitle class="d-flex justify-space-between align-center pt-0 pb-4">
          <div class="d-flex">
            <img
                :src="require(`@/assets/icons/hand-heart-outline.${isPdf ? 'png' : 'svg'}`)"
                width="18"
                contain
                class="mr-2"
            />
            <span style="color: #202020">{{ this.partnerAnalytics.totalSponsors }} partners</span>
          </div>
        </v-card-subtitle>
<!--        <v-divider/>-->
        <div v-for="(item, index) in partnersData" class="px-4" :key="item.name">
          <AnalyticsDetailRow :title="item.name" :value="item.value" :show-view-button="true" @onView="view(item.name)"/>
        <v-divider v-if="index != partnersData.length-1"/>
        </div>
      </div>
    </v-card>
  </div>
</template>

<style scoped>

</style>